import { setWebIcon, setWebTitle } from '@/utils'
import logoSvg from '@/assets/icons/app/logo.svg'
import { checkOkrPremision } from './../pages/user/hook/useCheckOkr'
const headerIns = () => import('./../pages/header/index.vue')
const OkrPages = [
  {
    path: 'okr',
    component: () => import('./../pages/layout/index.vue'),
    redirect: '/okr/user',
    beforeEnter() {
      setWebIcon(logoSvg)
      setWebTitle('OKR')
      return checkOkrPremision()
    },
    children: [
      {
        path: 'user',
        components: {
          header: headerIns,
          default: () => import('./../pages/user/index.vue')
        },
        meta: {
          title: '目标'
        }
      },
      // {
      //   path: 'alignment',
      //   components: {
      //     header: headerIns,
      //     default: () => import('./../pages/alignment/index.vue')
      //   },
      //   meta: {
      //     title: '对齐'
      //   }
      // }
    ]
  }
]
export default OkrPages
